interface Message {
  id: number
  name: string
  email: string
  subject: string
  message: string
  created_at: string
  is_read: boolean
}

interface RecentMessagesProps {
  messages: Message[]
  loading: boolean
}

function RecentMessages({ messages, loading }: RecentMessagesProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    const hours = Math.floor(diff / (1000 * 60 * 60))
    const days = Math.floor(hours / 24)

    if (days > 0) {
      return `Il y a ${days} jour${days > 1 ? 's' : ''}`
    } else if (hours > 0) {
      return `Il y a ${hours} heure${hours > 1 ? 's' : ''}`
    } else {
      return "Il y a moins d'1 heure"
    }
  }

  return (
    <div className="recent-messages">
      <h2 className="section-title">Derniers messages</h2>

      {loading ? (
        <div className="loading-messages">
          <div className="spinner"></div>
          <p>Chargement des messages...</p>
        </div>
      ) : messages.length === 0 ? (
        <div className="no-messages">
          <p>Aucun message reçu</p>
        </div>
      ) : (
        <div className="messages-list">
          {messages.map((message) => (
            <div
              key={message.id}
              className={`message-item ${!message.is_read ? 'message-unread' : ''}`}
            >
              <div className="message-header">
                <div className="message-from">
                  <strong>{message.name}</strong>
                  {!message.is_read && <span className="unread-badge">Nouveau</span>}
                </div>
                <div className="message-date">{formatDate(message.created_at)}</div>
              </div>
              <div className="message-subject">{message.subject}</div>
              <div className="message-preview">
                {message.message.substring(0, 80)}
                {message.message.length > 80 ? '...' : ''}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default RecentMessages
